import fetch from "@/fetch";
// 通过排版id获取详情
export const screenMaterialDetailGet = (params) => {
  return fetch({
    method: "post",
    url: "/common/h5/largescreen/getone",
    data: params,
    actionTypeCode: "39",
    actionTypeDesc: "大屏排版信息详情获取",
    loading: true,
  });
};

// 大屏弹幕发送
export const screenMaterialBarrageSend = (params) => {
  return fetch({
    method: "post",
    url: "/common/h5/sendbarrage",
    data: params,
    actionTypeCode: "40",
    actionTypeDesc: "大屏弹幕发送",
    loading: true,
  });
};

// 大屏弹幕点赞
export const screenMaterialBarrageLike = (params) => {
  return fetch({
    method: "post",
    url: "/common/h5/likebarrage",
    data: params,
    actionTypeCode: "41",
    actionTypeDesc: "大屏弹幕点赞",
  });
};

// 大屏交互弹幕列表获取
export const screenMaterialBarrageListGet = (params) => {
  return fetch({
    method: "post",
    url: "/common/h5/largescreen/getbarragelist",
    data: params,
    actionTypeCode: "42",
    actionTypeDesc: "大屏交互弹幕获取",
  });
};
